import { ACTION } from './reducer';
import type { DashboardAction, State as DashboardState } from './reducer';

const actions = {
  updateAnyProperty({
    reducerDispatch,
    data,
  }: {
    reducerDispatch: ({ type, payload }: DashboardAction) => void;
    data: Partial<DashboardState>;
  }) {
    reducerDispatch({
      type: ACTION.UPDATE_ANY_KEY,
      payload: {
        ...data,
      },
    });
  },
};

export default actions;
